'use client';

import type { ReactNode } from 'react';
import { useDeferredQueryEnabled } from '@/hooks/use-deferred-query-enabled';

/**
 * Mounts the issue-tracker sections after the PR page's startup request window. Each tracker
 * fires its own connection and linked-issue fetches, so holding them keeps navigations from
 * queueing behind them. Shared by the PR page sidebar and the /code PR tab.
 */
export function DeferredIssueTrackers(t0) {
  const {
    children
  } = t0;
  const isPastStartupWindow = useDeferredQueryEnabled();
  return isPastStartupWindow ? children : null;
}